import { useState } from "react";
import { styled } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Map } from "leaflet";

import { useMapPosition } from "hooks/mapHooks";
import { useUuidContext } from "hooks/routerHooks";

import { CollapsibeDrawer } from "components/layout/CollapsibleDrawer";
import { MapContent } from "components/map/MapContent";
import { Footer } from "components/layout/Footer";
import { LoadingBox } from "components/map/LoadingBox";
import { MainWithFooterStyles } from "./MainWithFooterStyles";

export function MapLayoutRightSideNav() {
  const [open, setOpen] = useState<boolean>(true);
  const [mapRef, setMapRef] = useState<Map | null>();
  const [footerRef, setFooterRef] = useState<HTMLDivElement | null>(null);
  const [mapOverlayContainer, setMapOverlayContainer] =
    useState<HTMLDivElement | null>(null);

  const { uuid } = useUuidContext();
  const { zoom, ...center } = useMapPosition();

  return (
    <>
      <Styles>
        <MapContent
          center={center}
          zoom={zoom}
          setMapRef={setMapRef}
          uuid={uuid}
        >
          <LoadingBox setMapOverlayContainer={setMapOverlayContainer} />
        </MapContent>
        <CollapsibeDrawer
          anchor="right"
          className={`panel ${open ? "open" : "closed"}`}
          onToggle={() => setOpen(!open)}
          open={open}
          padding={0}
          variant="persistent"
          elevation={0}
        >
          {mapRef && mapOverlayContainer && footerRef && (
            <Outlet
              context={{
                mapRef: mapRef,
                footerRef: footerRef,
                uuid: uuid,
                mapOverlayContainer: mapOverlayContainer,
              }}
            />
          )}
        </CollapsibeDrawer>
      </Styles>
      <Footer setFooterRef={setFooterRef} />
    </>
  );
}
const Styles = styled(MainWithFooterStyles)`
  .panel {
    display: flex;
    justify-content: stretch;
    transition: flex-basis 320ms ease-out;
    max-width: ${({ theme }) => theme.spacing(100)};
    min-width: 600px;
    flex: 1 1 100%;
    &.closed {
      min-width: 0;
      flex: 0 1 0%;
    }
  }
`;
